import React from 'react';
import { Field, FormSection } from 'redux-form';
import Typography from '@material-ui/core/Typography';

import Fields from 'components/Fields';
import { wizardStyles } from 'components/Forms/Wizard/wizardUtils';
import { useFormatMessage } from 'components/IntlProvider';

interface CountryType {
  name: string;
  code: string;
}

interface CountryProps {
  countries: CountryType[];
}

const Country = ({ countries }: CountryProps) => {
  const classes = wizardStyles();
  const t = useFormatMessage();
  return (
    <>
      <Typography
        component="h2"
        variant="subtitle1"
        color="inherit"
        className={classes.subtitle}
      >
        {t('fields.wizard.country', 'Country')}
      </Typography>
      <FormSection name="audience_country">
        {countries.map(({ name, code }: CountryType) => (
          <Field
            fullWidth
            key={code}
            component={Fields.Checkbox}
            value={code}
            label={name}
            name={code}
          />
        ))}
      </FormSection>
    </>
  );
};

export default Country;
